/**
 * Generated by orval v8.5.3 🍺
 * Do not edit manually.
 * metapic-api
 * Metapic API
 * OpenAPI spec version: 0.0.1
 */
import * as axios from 'axios'
import type { AxiosInstance, AxiosRequestConfig, AxiosResponse } from 'axios'

import type {
  CampaignParticipantResource,
  CreateOffer200,
  CreateOrUpdateOfferRequest,
  GetOfferStatistics200,
  GetOfferStatisticsParams,
  ListOffers200,
  ListOffersParams,
  ListUserCampaignListParticipants200,
  ListUserCampaignListParticipantsParams,
  ListUserFeaturedCampaigns200,
  OfferByTokenShowParams,
  OfferResource,
  UpdateOffer200,
  UploadRequest,
  UserOffersShowParams,
} from '../metapicApi.schemas'

export const getOffer = (axiosInstance: AxiosInstance = axios.default) => {
  /**
   * Creates new campaign for a store.
   * @summary Create campaign
   */
  const createOffer = (
    store: number,
    createOrUpdateOfferRequest: CreateOrUpdateOfferRequest,
    options?: AxiosRequestConfig,
  ): Promise<AxiosResponse<CreateOffer200>> => {
    return axiosInstance.post(`/v2/stores/${store}/offers`, createOrUpdateOfferRequest, options)
  }
  /**
   * Returns information about a specific campaign.
   * @summary Display campaign
   */
  const userOffersShow = (
    offer: number,
    params?: UserOffersShowParams,
    options?: AxiosRequestConfig,
  ): Promise<AxiosResponse<OfferResource>> => {
    return axiosInstance.get(`/v2/offers/${offer}`, {
      ...options,
      params: { ...params, ...options?.params },
    })
  }
  /**
   * Updates existing campaign.
   * @summary Update campaign
   */
  const updateOffer = (
    offer: number,
    createOrUpdateOfferRequest: CreateOrUpdateOfferRequest,
    options?: AxiosRequestConfig,
  ): Promise<AxiosResponse<UpdateOffer200>> => {
    return axiosInstance.put(`/v2/offers/${offer}`, createOrUpdateOfferRequest, options)
  }
  /**
   * Soft deletes a campaign.
   * @summary Delete campaign
   */
  const deleteOffer = (
    offer: number,
    options?: AxiosRequestConfig,
  ): Promise<AxiosResponse<void>> => {
    return axiosInstance.delete(`/v2/offers/${offer}`, options)
  }
  /**
   * Endpoint for querying & sorting all campaigns.
   * @summary List campaigns
   */
  const listOffers = (
    params?: ListOffersParams,
    options?: AxiosRequestConfig,
  ): Promise<AxiosResponse<ListOffers200>> => {
    return axiosInstance.get(`/v2/offers`, {
      ...options,
      params: { ...params, ...options?.params },
    })
  }
  /**
   * Uploads an image to a campaign.
   * @summary Upload campaign image
   */
  const uploadOfferImage = (
    offer: number,
    uploadRequest: UploadRequest,
    options?: AxiosRequestConfig,
  ): Promise<AxiosResponse<OfferResource>> => {
    const formData = new FormData()
    formData.append(`default`, uploadRequest.default)

    return axiosInstance.post(`/v2/offers/${offer}/uploads`, formData, options)
  }
  /**
   * @summary Pause campaign
   */
  const pauseOffer = (
    offer: number,
    options?: AxiosRequestConfig,
  ): Promise<AxiosResponse<OfferResource>> => {
    return axiosInstance.post(`/v2/offers/${offer}/pause`, undefined, options)
  }
  /**
   * @summary Unpause campaign
   */
  const unpauseOffer = (
    offer: number,
    options?: AxiosRequestConfig,
  ): Promise<AxiosResponse<OfferResource>> => {
    return axiosInstance.post(`/v2/offers/${offer}/unpause`, undefined, options)
  }
  /**
   * Returns statistics about a specific campaign.
   * @summary Display campaign stats
   */
  const getOfferStatistics = (
    offer: number,
    params: GetOfferStatisticsParams,
    options?: AxiosRequestConfig,
  ): Promise<AxiosResponse<GetOfferStatistics200>> => {
    return axiosInstance.get(`/v2/offers/${offer}/stats`, {
      ...options,
      params: { ...params, ...options?.params },
    })
  }
  /**
   * @summary Add affiliate link to campaign
   */
  const offerAddAffiliateLink = (
    offer: number,
    tag: number,
    options?: AxiosRequestConfig,
  ): Promise<AxiosResponse<string[]>> => {
    return axiosInstance.put(`/v2/offers/${offer}/affiliate-links/${tag}`, undefined, options)
  }
  /**
   * @summary Remove affiliate link from campaign
   */
  const offerRemoveAffiliateLink = (
    offer: number,
    tag: number,
    options?: AxiosRequestConfig,
  ): Promise<AxiosResponse<string[]>> => {
    return axiosInstance.delete(`/v2/offers/${offer}/affiliate-links/${tag}`, options)
  }
  /**
   * Returns campaigns that are not of type "standard" with additional information about user participation. It also allows filtering by title, multiple campaign and participant statuses.
   * @summary Get User Campaigns
   */
  const listUserCampaignListParticipants = (
    user: number,
    params?: ListUserCampaignListParticipantsParams,
    options?: AxiosRequestConfig,
  ): Promise<AxiosResponse<ListUserCampaignListParticipants200>> => {
    return axiosInstance.get(`/v2/users/${user}/campaigns`, {
      ...options,
      params: { ...params, ...options?.params },
    })
  }
  /**
   * Returns active featured campaigns that have an image, with user participation information.
   * @summary Get User Featured Campaigns
   */
  const listUserFeaturedCampaigns = (
    user: number,
    options?: AxiosRequestConfig,
  ): Promise<AxiosResponse<ListUserFeaturedCampaigns200>> => {
    return axiosInstance.get(`/v2/users/${user}/featured-campaigns`, options)
  }
  /**
   * Returns specific campaign details along with available state transitions for the user.
   * @summary Get User Campaign Details
   */
  const getUserCampaign = (
    user: number,
    offer: number,
    options?: AxiosRequestConfig,
  ): Promise<AxiosResponse<CampaignParticipantResource>> => {
    return axiosInstance.get(`/v2/users/${user}/campaigns/${offer}`, options)
  }
  /**
   * Returns information about a specific campaign.
   * @summary Display campaign
   */
  const offerByTokenShow = (
    offer: number,
    params?: OfferByTokenShowParams,
    options?: AxiosRequestConfig,
  ): Promise<AxiosResponse<OfferResource>> => {
    return axiosInstance.get(`/v2/offer-by-token/${offer}`, {
      ...options,
      params: { ...params, ...options?.params },
    })
  }
  return {
    createOffer,
    userOffersShow,
    updateOffer,
    deleteOffer,
    listOffers,
    uploadOfferImage,
    pauseOffer,
    unpauseOffer,
    getOfferStatistics,
    offerAddAffiliateLink,
    offerRemoveAffiliateLink,
    listUserCampaignListParticipants,
    listUserFeaturedCampaigns,
    getUserCampaign,
    offerByTokenShow,
  }
}
export type CreateOfferResult = AxiosResponse<CreateOffer200>
export type UserOffersShowResult = AxiosResponse<OfferResource>
export type UpdateOfferResult = AxiosResponse<UpdateOffer200>
export type DeleteOfferResult = AxiosResponse<void>
export type ListOffersResult = AxiosResponse<ListOffers200>
export type UploadOfferImageResult = AxiosResponse<OfferResource>
export type PauseOfferResult = AxiosResponse<OfferResource>
export type UnpauseOfferResult = AxiosResponse<OfferResource>
export type GetOfferStatisticsResult = AxiosResponse<GetOfferStatistics200>
export type OfferAddAffiliateLinkResult = AxiosResponse<string[]>
export type OfferRemoveAffiliateLinkResult = AxiosResponse<string[]>
export type ListUserCampaignListParticipantsResult =
  AxiosResponse<ListUserCampaignListParticipants200>
export type ListUserFeaturedCampaignsResult = AxiosResponse<ListUserFeaturedCampaigns200>
export type GetUserCampaignResult = AxiosResponse<CampaignParticipantResource>
export type OfferByTokenShowResult = AxiosResponse<OfferResource>
